export default "__VITE_ASSET__CFGYmxH0__"